import { render } from "./ZapiBackButton.vue?vue&type=template&id=76e9b5aa&scoped=true"
import script from "./ZapiBackButton.vue?vue&type=script&lang=js"
export * from "./ZapiBackButton.vue?vue&type=script&lang=js"

import "./ZapiBackButton.vue?vue&type=style&index=0&id=76e9b5aa&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e9b5aa"]])

export default __exports__